import { useState, type FormEvent } from 'react';
import { Button } from '../../components/Button/Button';
import styles from './CreateGoalModal.module.css';

interface Props {
  onClose(): void;
  onCreate(input: {
    name: string;
    target: number | null;
    start_amount: number | null;
  }): Promise<void>;
}

function parseInt0(v: string): number | null {
  const cleaned = v.replace(/[^0-9]/g, '');
  if (cleaned === '') return null;
  return parseInt(cleaned, 10);
}

export function CreateGoalModal({ onClose, onCreate }: Props) {
  const [name, setName] = useState('');
  const [start, setStart] = useState('');
  const [target, setTarget] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    try {
      await onCreate({
        name: name.trim(),
        target: parseInt0(target),
        start_amount: parseInt0(start),
      });
      onClose();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className={styles.overlay} onClick={onClose}>
      <form className={styles.card} onClick={(e) => e.stopPropagation()} onSubmit={onSubmit}>
        <div className={styles.top}>
          <div>
            <h3 className={styles.title}>Ny opsparing</h3>
            <p className={styles.sub}>
              Giv opsparingen et navn, et startbeløb, og evt. et beløb at spare op mod.
            </p>
          </div>
          <button type="button" className={styles.close} onClick={onClose}>
            ×
          </button>
        </div>
        <div className={styles.form}>
          <div className={styles.field}>
            <label className={styles.label} htmlFor="goal-name">
              Navn
            </label>
            <input
              id="goal-name"
              className={styles.input}
              placeholder="fx Sommerhus"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className={styles.pair}>
            <div className={styles.field}>
              <label className={styles.label} htmlFor="goal-start">
                Startbeløb
              </label>
              <input
                id="goal-start"
                className={styles.input}
                inputMode="numeric"
                placeholder="0"
                value={start}
                onChange={(e) => setStart(e.target.value)}
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label} htmlFor="goal-target">
                Målbeløb <span className={styles.optional}>(valgfrit)</span>
              </label>
              <input
                id="goal-target"
                className={styles.input}
                inputMode="numeric"
                placeholder="—"
                value={target}
                onChange={(e) => setTarget(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className={styles.actions}>
          <Button variant="secondary" type="button" onClick={onClose}>
            Annullér
          </Button>
          <Button variant="primary" type="submit" disabled={busy}>
            {busy ? 'Opretter…' : 'Opret opsparing'}
          </Button>
        </div>
      </form>
    </div>
  );
}
